import type { PostCard } from '../types'

type CoverCandidate = Partial<PostCard> | null | undefined

export function resolveLandscapeCover(post: CoverCandidate): string | null {
  if (!post) return null
  return (
    post.cover?.landscape?.url ||
    post.cover_variants?.landscape ||
    post.cover_landscape_url ||
    post.cover?.portrait?.url ||
    post.cover_variants?.portrait ||
    post.cover_image_url ||
    post.cover_portrait_url ||
    post.fallback_cover_url ||
    null
  )
}

export function resolvePortraitCover(post: CoverCandidate): string | null {
  if (!post) return null
  return (
    post.cover?.portrait?.url ||
    post.cover_portrait_url ||
    post.cover_variants?.portrait ||
    post.cover_image_url ||
    post.cover?.landscape?.url ||
    post.cover_variants?.landscape ||
    post.cover_landscape_url ||
    post.fallback_cover_url ||
    null
  )
}
